import { useCallback, useRef } from 'react';
import { Box, Modal, ModalContent, ModalOverlay, ModalFooter } from '@chakra-ui/react';
import { Button, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import GroupNameInput from 'components/widgets/ProjectGroupEdit/EditFiltersStep/GroupNameInput';
import { useSaveGroup } from 'hooks/useSaveGroup';

const contentStyle = {
  maxWidth: '300px',
  width: '100%',
};

const titleStyle = {
  paddingBottom: 'padding_16',
};

const modalBodyStyle = {
  padding: 'padding_16',
  paddingBottom: '0px',
};

const modalFooterStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: 'padding_16',
};

type SaveGroupModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (arg0: number) => void;
};

const SaveGroupModal = ({ isOpen, onClose, onSuccess }: SaveGroupModalProps) => {
  const { saveGroup } = useSaveGroup();
  const saveButtonRef = useRef<HTMLButtonElement>(null);

  const onSaveClick = useCallback(() => {
    if (saveGroup.isLoading) {
      return;
    }
    saveGroup.mutate({ onSuccessCallback: onSuccess });
  }, [saveGroup, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent sx={contentStyle}>
        <FlexColumn>
          <Box sx={modalBodyStyle}>
            <Text.Lead sx={titleStyle}>Name your search</Text.Lead>
            <GroupNameInput onEnter={() => saveButtonRef.current?.click()} />
          </Box>
          <ModalFooter sx={modalFooterStyle}>
            <Button
              variant="functional"
              onClick={onClose}
              isDisabled={saveGroup.isLoading}
            >
              Cancel
            </Button>
            <Button
              ref={saveButtonRef}
              variant="primary"
              onClick={onSaveClick}
              isLoading={saveGroup.isLoading}
            >
              Create new saved search
            </Button>
          </ModalFooter>
        </FlexColumn>
      </ModalContent>
    </Modal>
  );
};

export default SaveGroupModal;
